import { SVGProps } from 'react';

const SvgSms = (props: SVGProps<SVGSVGElement>) => (
  <svg width="31" height="30" viewBox="0 0 31 30" fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M15.5 27.5C22.4036 27.5 28 21.9036 28 15C28 8.09644 22.4036 2.5 15.5 2.5C8.59644 2.5 3 8.09644 3 15C3 16.9996 3.46952 18.8895 4.30433 20.5656C4.52617 21.011 4.60001 21.5201 4.4714 22.0008L3.72689 24.7833C3.40369 25.9912 4.50877 27.0963 5.71668 26.7731L8.49923 26.0286C8.97992 25.9 9.48901 25.9738 9.93441 26.1957C11.6105 27.0305 13.5004 27.5 15.5 27.5Z"
      stroke="#2196F3"
      strokeWidth="1.5"
    />
    <path d="M10.5 13.125H20.5" stroke="#2196F3" strokeWidth="1.5" strokeLinecap="round" />
    <path d="M10.5 17.5H17.375" stroke="#2196F3" strokeWidth="1.5" strokeLinecap="round" />
  </svg>
);
export default SvgSms;
